"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
(function () {
  'use strict';

  var REDIRECTS = {
    client: '/carehub',
    carer: '/get-carer-app',
    partner: '/partners'
  };
  function apiRequest(endpoint, body) {
    var cfg = window.htConfig || {};
    return fetch(cfg.apiBase + endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Basic ' + btoa(cfg.authCredentials || '')
      },
      body: JSON.stringify(body)
    }).then(function (resp) {
      if (!resp.ok) {
        return resp.json().then(function (data) {
          throw data;
        });
      }
      return resp.json();
    });
  }
  function showScreen(screenId) {
    var screens = document.querySelectorAll('.login-screen');
    for (var i = 0; i < screens.length; i++) {
      screens[i].classList.remove('active');
    }
    document.getElementById(screenId).classList.add('active');
  }
  function isLoggedIn() {
    try {
      var auth = JSON.parse(localStorage.getItem('auth'));
      if (auth && auth.exp > new Date().getTime() / 1000) {
        return auth;
      }
    } catch (e) {}
    return null;
  }
  function redirectByUserType(userType) {
    window.location.href = REDIRECTS[userType] || '/';
  }
  function validateEmail(email) {
    return /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i.test(email);
  }
  function setFieldError(input, message) {
    var error = input.parentNode.querySelector('.field-error');
    if (message) {
      input.classList.add('has-error');
      error.textContent = message;
    } else {
      input.classList.remove('has-error');
      error.textContent = '';
    }
  }


  function initLoginForm() {
    var form = document.getElementById('login-form');
    if (!form) return;
    var emailInput = document.getElementById('login-email');
    var passwordInput = document.getElementById('login-password');
    var submitBtn = form.querySelector('.login-submit');
    var formError = form.querySelector('.form-error');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      var password = passwordInput.value;
      var valid = true;
      if (!email) {
        setFieldError(emailInput, 'Email is required');
        valid = false;
      } else if (!validateEmail(email)) {
        setFieldError(emailInput, 'Please enter a valid email');
        valid = false;
      } else {
        setFieldError(emailInput, '');
      }
      if (!password) {
        setFieldError(passwordInput, 'Password is required');
        valid = false;
      } else {
        setFieldError(passwordInput, '');
      }
      if (!valid) return;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Logging in...';
      formError.style.display = 'none';
      apiRequest('/users/auth/login', {
        username: email,
        password: password,
        grant_type: 'password'
      }).then(function (res) {
        console.log(res);
        var payload = JSON.parse(atob(res.access_token.split('.')[1]));
        var data = _objectSpread(_objectSpread({}, res), payload);
        var userType = data.user_type;
        if (['client', 'carer', 'partner'].indexOf(userType) === -1) {
          throw {
            error: 'Unsupported account type'
          };
        }
        localStorage.setItem('auth', JSON.stringify(data));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'loginFormSubmitted',
          formName: 'Login'
        });
        redirectByUserType(userType);
      })["catch"](function (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Login';
        passwordInput.value = '';
        var message = err && err.error || 'Login failed. Please try again.';
        formError.textContent = message;
        formError.style.display = 'block';
      });
    });
  }


  function initForgotForm() {
    var form = document.getElementById('forgot-form');
    if (!form) return;
    var emailInput = document.getElementById('forgot-email');
    var submitBtn = form.querySelector('.login-submit');
    var formError = form.querySelector('.form-error');

    var showForgot = document.getElementById('show-forgot');
    var showLogin = document.getElementById('show-login');
    var backToLogin = document.getElementById('back-to-login');
    if (showForgot) {
      showForgot.addEventListener('click', function (e) {
        e.preventDefault();
        showScreen('forgot-screen');
      });
    }
    if (showLogin) {
      showLogin.addEventListener('click', function (e) {
        e.preventDefault();
        showScreen('login-screen');
      });
    }
    if (backToLogin) {
      backToLogin.addEventListener('click', function (e) {
        e.preventDefault();
        showScreen('login-screen');
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!email) {
        setFieldError(emailInput, 'Email is required');
        return;
      } else if (!validateEmail(email)) {
        setFieldError(emailInput, 'Please enter a valid email');
        return;
      } else {
        setFieldError(emailInput, '');
      }
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
      formError.style.display = 'none';
      apiRequest('/users/auth/forgot-password', {
        email: email
      }).then(function () {
        showScreen('forgot-confirm-screen');
      })["catch"](function () {
        showScreen('forgot-confirm-screen');
      });
    });
  }


  function initResetForm() {
    var form = document.getElementById('reset-form');
    if (!form) return;
    var token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      showScreen('reset-error-screen');
      return;
    }
    var passwordInput = document.getElementById('reset-password');
    var confirmInput = document.getElementById('reset-confirm');
    var submitBtn = form.querySelector('.login-submit');
    var formError = form.querySelector('.form-error');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var password = passwordInput.value;
      var confirm = confirmInput.value;
      var valid = true;
      if (!password) {
        setFieldError(passwordInput, 'Password is required');
        valid = false;
      } else if (password.length < 8) {
        setFieldError(passwordInput, 'Password must be at least 8 characters');
        valid = false;
      } else {
        setFieldError(passwordInput, '');
      }
      if (!confirm) {
        setFieldError(confirmInput, 'Please confirm your password');
        valid = false;
      } else if (password !== confirm) {
        setFieldError(confirmInput, 'Passwords do not match');
        valid = false;
      } else {
        setFieldError(confirmInput, '');
      }
      if (!valid) return;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Resetting...';
      formError.style.display = 'none';
      apiRequest('/users/auth/reset-password', {
        token: token,
        newPassword: password
      }).then(function () {
        showScreen('reset-success-screen');
      })["catch"](function (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Reset password';
        var message = err && err.error || 'Something went wrong. Please try again.';
        if (err && err.code === 401) {
          showScreen('reset-error-screen');
          return;
        }
        formError.textContent = message;
        formError.style.display = 'block';
      });
    });
  }


  if (document.getElementById('login-form')) {
    var auth = isLoggedIn();
    if (auth) {
      redirectByUserType(auth.user_type);
      return;
    }
  }
  function init() {
    initLoginForm();
    initForgotForm();
    initResetForm();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();